import React from 'react';
import Header from './components/Header';
import StorySection from './components/StorySection';
import PainSection from './components/PainSection';
import DiscoverySection from './components/DiscoverySection';
import SolutionSection from './components/SolutionSection';
import TestimonialSection from './components/TestimonialSection';
import TransformationSection from './components/TransformationSection';
import CTASection from './components/CTASection';
import FloatingCTA from './components/FloatingCTA';
export function App() {
  return <div className="w-full min-h-full bg-gray-50 font-sans text-gray-800" data-id="element-0">
      <Header data-id="element-1" />
      <StorySection data-id="element-2" />
      <PainSection data-id="element-3" />
      <DiscoverySection data-id="element-4" />
      <SolutionSection data-id="element-5" />
      <TestimonialSection data-id="element-6" />
      <TransformationSection data-id="element-7" />
      <CTASection data-id="element-8" />
      <FloatingCTA data-id="element-9" />
    </div>;
}